export const environment = {
  production: false,
  baseUrl: 'https://validador-qa.afpcapital.cl/api/bff',
};
